import { render, staticRenderFns } from "./VariationPrice.vue?vue&type=template&id=34908bde&scoped=true"
import script from "./VariationPrice.vue?vue&type=script&lang=ts"
export * from "./VariationPrice.vue?vue&type=script&lang=ts"
import style0 from "./VariationPrice.vue?vue&type=style&index=0&id=34908bde&lang=scss"
import style1 from "./VariationPrice.vue?vue&type=style&index=1&id=34908bde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34908bde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34908bde')) {
      api.createRecord('34908bde', component.options)
    } else {
      api.reload('34908bde', component.options)
    }
    module.hot.accept("./VariationPrice.vue?vue&type=template&id=34908bde&scoped=true", function () {
      api.rerender('34908bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/VariationPrice.vue"
export default component.exports